import { useRef, useEffect } from "react";

const UseIntersectionObserver = (
  element: HTMLElement | null,
  threshold: number,
  callback: () => void,
) => {
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    return () => {
      if (observerRef.current !== null) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  const observerOptions: IntersectionObserverInit = {
    root: null,
    rootMargin: "0px",
    threshold,
  };

  const observerCallback = (
    observations: IntersectionObserverEntry[],
    observer: IntersectionObserver,
  ) => {
    const observation = observations[0];
    if (
      observation !== undefined &&
      observation.isIntersecting &&
      observation.intersectionRatio >= threshold
    ) {
      callback();

      observer.disconnect();
    }
  };

  if (element !== null && observerRef.current === null) {
    observerRef.current = new IntersectionObserver(
      observerCallback,
      observerOptions,
    );

    observerRef.current.observe(element);
  }
};

export default UseIntersectionObserver;
